import { LeaveIcon } from 'static';
import styled from 'styled-components';
import { breakpoints } from 'theme';

export const StyledFloatingLoader = styled.div`
  position: fixed;
  width: 70px;
  height: 70px;
  right: 50px;
  top: 50px;
  background: #ffffffbf;
  border-radius: 50%;
  z-index: 100;
  box-shadow: 0px 0px 10px 0px #21cec9;
`;

export const ListWrapper = styled.div`
  @media ${breakpoints.downLg} {
    overflow: scroll hidden;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  text-align: center;
  padding: 40px 20px;
`;

export const EmptyStateIcon = styled.div`
  font-size: 62px;
  margin-bottom: 16px;
`;

export const EmptyStateTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  color: ${({ theme }) => theme.color.pickledBluewood};
  margin: 0 0 6px 0;
  letter-spacing: -0.255px;

  @media ${breakpoints.downMd} {
    font-size: 16px;
    line-height: 1.2;
  }

  @media ${breakpoints.downSmPlus} {
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
  }
`;

export const EmptyStateDescription = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.color.baliHai};
  margin: 0 0 24px 0;
  max-width: 400px;
  white-space: pre-wrap;
  line-break: normal;
  text-align: center;
  position: relative;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  height: 40px;
  background-color: ${({ theme }) => theme.color.blackSqueeze};
  padding: 0 25px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.baliHai};
`;

export const HeaderColumn = styled.div`
  width: ${({ width }) => width || 'auto'};
  display: flex;
  align-items: center;
  justify-content: ${({ center }) => (center ? 'center' : 'flex-start')};

  &:first-child {
    padding-left: 0;
    width: 40%;
  }

  &:nth-of-type(2) {
    width: 30%;
  }

  &:nth-of-type(3) {
    width: 10%;
    justify-content: center;
  }

  &:nth-of-type(4) {
    width: 10%;
    justify-content: center;
  }

  &:nth-of-type(5) {
    width: 10%;
    justify-content: flex-end;
  }
`;

export const Row = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  padding: 0 25px;
  border-bottom: 1px solid ${({ theme }) => theme.color.porcelain};
  background-color: ${({ theme }) => theme.color.white};

  &:hover {
    background-color: ${({ theme }) => theme.color.blackSqueeze};
  }

  /* Add border during drag */
  &[data-rbd-dragging='true'] {
    border: 2px solid ${({ theme }) => theme.color.brightTurquoise};
    border-radius: 4px;
  }
`;

export const RowColumn = styled.div`
  width: ${({ width }) => width || 'auto'};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: ${({ center }) => (center ? 'center' : 'flex-start')};
  color: ${({ theme }) => theme.color.pickledBluewood};
  font-size: 14px;
  font-weight: normal;
  overflow: hidden;

  &:first-child {
    padding-left: 0;
    width: 40%;
  }

  &:nth-of-type(2) {
    width: 30%;
  }

  &:nth-of-type(3) {
    width: 10%;
    justify-content: center;
  }

  &:nth-of-type(4) {
    width: 10%;
    justify-content: center;
  }

  &:nth-of-type(5) {
    width: 10%;
    justify-content: flex-start;
  }
`;

const Community = styled.div`
  display: flex;
  align-items: center;
`;

Community.Wrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

Community.Logo = styled.div`
  display: flex;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.color.porcelain};
  margin-right: 12px;
`;

Community.Logo.Image = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

Community.Name = styled.div``;

Community.Icon = styled(LeaveIcon)`
  width: 15px;
  height: 18px;
  cursor: pointer;
`;

Community.Leave = styled.a`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    ${Community.Icon} {
      path {
        fill: ${({ theme }) => theme.color.pickledBluewood};
      }
    }

    span {
      color: ${({ theme }) => theme.color.pickledBluewood};
    }
  }

  &:active {
    ${Community.Icon} {
      path {
        fill: ${({ theme }) => theme.color.brightTurquoise};
      }
    }

    span {
      color: ${({ theme }) => theme.color.brightTurquoise};
    }
  }
`;

// Simple drag handle styling like in group members
export const DragHandleCell = styled.div`
  width: 44px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const ListLoader = styled.div`
  margin-top: 25px;
  position: relative;
`;

export { Community };
